import styled, { css } from "styled-components"
import breakpoint from "styled-components-breakpoint"
import CloseIcon from "../close-icon"

export const Container = styled.div`
  font-family: ${({ theme }) => theme.fonts.body.family}, sans-serif;
  position: fixed;
  z-index: 51;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgb(0, 0, 0);
  background-color: rgb(0, 0, 0, 0.4);
  box-sizing: border-box;
  user-select: none;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  overflow: hidden;

  ${breakpoint("desktop")`
    padding: ${({ maskVerticalOffset }) => css`
      ${maskVerticalOffset}px;
    `}
  `}

  ${(props) =>
    !props.show &&
    css`
      display: none;
    `}

  ${(props) =>
    props.show &&
    css`
      display: flex;
    `}
`

export const Box = styled.div`
  z-index: 3;
  cursor: default;
  width: 100%;
  height: 100%;
  background-color: white;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;

  ${({ smallSize }) =>
    smallSize
      ? css`
          max-width: 960px;
        `
      : css`
          max-width: 1240px;
        `}

  ${({ fullSize }) =>
    fullSize &&
    css`
      max-width: 1400px;
    `}

  ${breakpoint("tablet")`
    border-radius: 1rem;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  `}
`

export const Aside = styled.aside`
  background-color: ${({ theme }) => theme.colors.primary};
  overflow-y: auto;

  ${({ profile }) =>
    !!profile &&
    css`
      background-color: transparent;
      display: none;

      ${breakpoint("tablet")`
        display: block;
      `}
    `}

  ${breakpoint("tablet")`
    width: 224px;
  `}
`

export const Content = styled.div`
  overflow-y: auto;
  user-select: text;
  flex: 1;
`

export const CloseButton = styled(CloseIcon)`
  position: absolute;
  top: 1rem;
  right: 1rem;
  fill: #fff;
  z-index: 9999;

  ${({ participantMode }) =>
    participantMode &&
    css`
      fill: #999;
      top: 0.75rem;
      right: 0.75rem;
    `}
`

export const MobileOnly = styled.div`
  display: block;

  ${breakpoint("tablet")`
    display: none;
  `}
`

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;

  ${breakpoint("tablet")`
    > :first-child {
      margin-right: 0rem;
    }
  `}
`
